<template>
  <div class="space-y-3">
    <div class="flex items-center gap-3">
      <span class="text-sm text-slate-500 shrink-0">可见性类型：</span>
      <el-radio-group :model-value="visibilityType" @change="onVisibilityChange">
        <el-radio value="INHERIT">继承父级</el-radio>
        <el-radio value="CUSTOM">自定义</el-radio>
      </el-radio-group>
    </div>

    <div v-if="visibilityType === 'CUSTOM'">
      <div class="flex items-center justify-between mb-2">
        <span class="text-sm font-medium text-slate-600">ACL 条目</span>
        <el-button size="small" type="primary" @click="addItem">添加</el-button>
      </div>
      <div class="space-y-2 max-h-64 overflow-y-auto">
        <div
          v-for="(item, idx) in aclItems"
          :key="idx"
          class="flex items-center gap-2 p-2 bg-slate-50 rounded"
        >
          <el-select
            :model-value="item.subjectType"
            class="!w-28 shrink-0"
            size="small"
            @update:model-value="onSubjectTypeChange(idx, $event)"
          >
            <el-option label="用户" value="USER" />
            <el-option label="部门" value="DEPT" />
            <el-option label="所有用户" value="ALL_AUTHENTICATED" />
          </el-select>
          <UserSelector
            v-if="item.subjectType === 'USER'"
            :key="`user-${idx}-${item.subjectType}`"
            :model-value="item.subjectValue"
            :multiple="true"
            placeholder="选择用户"
            class="flex-1 min-w-0 max-w-full"
            @update:model-value="updateItem(idx, { subjectValue: $event })"
          />
          <DeptSelector
            v-else-if="item.subjectType === 'DEPT'"
            :key="`dept-${idx}-${item.subjectType}`"
            :model-value="item.subjectValue"
            :multiple="true"
            placeholder="选择部门"
            class="flex-1 min-w-0 max-w-full"
            @update:model-value="updateItem(idx, { subjectValue: $event })"
          />
          <span v-else class="flex-1 min-w-0 text-xs text-slate-400">所有认证用户</span>
          <el-select
            :model-value="item.permissionLevel"
            class="!w-24 shrink-0"
            size="small"
            @update:model-value="updateItem(idx, { permissionLevel: $event })"
          >
            <el-option label="查看" value="VIEW" />
            <el-option label="管理" value="MANAGE" />
          </el-select>
          <el-button text size="small" type="danger" class="shrink-0" @click="removeItem(idx)">
            <el-icon :size="14"><Delete /></el-icon>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Delete } from '@element-plus/icons-vue'
import UserSelector from '@/components/UserSelector/index.vue'
import DeptSelector from '@/views/system/components/DeptSelector/index.vue'

const props = defineProps({
  visibilityType: { type: String, default: 'INHERIT' },
  aclItems: { type: Array, default: () => [] }
})

const emit = defineEmits(['update:visibilityType', 'update:aclItems'])

function onVisibilityChange(val) {
  emit('update:visibilityType', val)
  if (val === 'INHERIT') {
    emit('update:aclItems', [])
  }
}

function addItem() {
  emit('update:aclItems', [
    ...props.aclItems,
    { subjectType: 'USER', subjectValue: [], permissionLevel: 'VIEW' }
  ])
}

function removeItem(idx) {
  emit('update:aclItems', props.aclItems.filter((_, index) => index !== idx))
}

function updateItem(idx, patch) {
  emit('update:aclItems', props.aclItems.map((item, index) => (
    index === idx ? { ...item, ...patch } : item
  )))
}

function onSubjectTypeChange(idx, subjectType) {
  updateItem(idx, { subjectType, subjectValue: [] })
}
</script>
